export default {
  google_md: "\\e96c",
  facebook_md: "\\e951",
  twitter_md: "\\e9ec",
  linkedin_md: "\\e98f",
  mail: "\\e99b",
  share: "\\e9ce"
};